module.exports = __webpack_public_path__ + "static/media/case-float-tip.24316f7c.png";